export default "/assets/images/CC-stats-graph-sm.10b13e9c59dc494e.webp";